import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = [
        'header',
        'input',
        'closeButton',
        'nav',
        'headerNavigationLeft'
    ];

    connect() {
        this.didScroll = false;
        this.lastScrollTop = 0;
        this.isSuspended = false;
        this.delta = 5;

        this.handleScroll = this.handleScroll.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);

        window.addEventListener('scroll', this.handleScroll);
        this.scrollCheck();

        document.addEventListener('mousedown', this.handleClickOutside);
    }

    disconnect() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    scrollCheck() {
        if (this.didScroll && !this.isSuspended) {
            this.#hasScrolled();
            this.didScroll = false;
        }

        requestAnimationFrame(this.scrollCheck.bind(this));
    }

    handleScroll() {
        this.didScroll = true;
    }

    hide() {
        $(this.headerTarget).removeClass('nav-down').addClass('nav-up');
    }

    show() {
        $(this.headerTarget).removeClass('nav-up').addClass('nav-down');
    }

    suspend() {
        this.isSuspended = true;
    }

    resume() {
        this.lastScrollTop = $(window).scrollTop();
        this.isSuspended = false;
    }

    open() {
        if (this.hasHeaderNavigationLeftTarget) {
            $(this.headerNavigationLeftTarget).addClass('search-active');
        }
    }

    close() {
        if (this.hasInputTarget) {
            this.inputTarget.value = '';
            this.inputTarget.blur();
        }
        document.activeElement.blur();

        if (this.hasHeaderNavigationLeftTarget) {
            $(this.headerNavigationLeftTarget).removeClass('search-active');
        }
    }

    handleClickOutside(event) {
        if (
            this.hasHeaderNavigationLeftTarget &&
            this.headerNavigationLeftTarget.classList.contains('search-active') &&
            !this.headerNavigationLeftTarget.contains(event.target)
        ) {
            this.close();
        }
    }

    #hasScrolled() {
        const headerNav = document.querySelector('.header-navigation');

        const checkWindowWidth = headerNav.classList.contains('show')
            ? window.innerWidth >= 1350
            : true;

        const scrollTop = window.scrollY;
        const navbarHeight = this.headerTarget.offsetHeight;

        const isScrollingDown = scrollTop > this.lastScrollTop;
        const isScrollingUp = scrollTop < this.lastScrollTop;

        const header = document.querySelector('.header');
        const btn = header.querySelector('.button');

        if (isScrollingDown && scrollTop > navbarHeight && checkWindowWidth) {
            this.headerTarget.classList.remove('nav-down', 'nav-down-active');
            this.headerTarget.classList.add('nav-up');
        }

        if (isScrollingUp && checkWindowWidth) {
            this.headerTarget.classList.remove('nav-up');

            if (scrollTop === 0) {
                this.headerTarget.classList.add('nav-down');
                this.headerTarget.classList.remove('nav-down-active');

                if (this.headerTarget.classList.contains('stage-nav')) {
                    btn.classList.remove('btn-primary');
                    btn.classList.add('btn-primary-inverted');
                }

            } else {
                this.headerTarget.classList.add('nav-down-active');
                this.headerTarget.classList.remove('nav-down');

                if (btn) {
                    btn.classList.add('btn-primary');
                    btn.classList.remove('btn-primary-inverted');
                }
            }
        }

        this.lastScrollTop = scrollTop;
    }
}
